import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, NumberSteps, CTABand, DisclaimerBox } from "../components/site/ContentBlocks";
import { SUPPLIER_STEPS, TRADING_DISCLAIMER } from "../data/content";

export default function Suppliers() {
    return (
        <div className="grain bg-navy-deep" data-testid="suppliers-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "How We Work with Suppliers | Reach International Buyers — Viet Medica Ltd",
                        description:
                            "Suppliers and exporters: connect with verified international buyers through Viet Medica Ltd's trading and sourcing coordination network.",
                        path: "/suppliers",
                    }}
                    crumbs={[{ label: "International Trading", href: "/international-trading" }, { label: "Suppliers" }]}
                    eyebrow="International Trading"
                    title="How We Work"
                    titleEm="with Suppliers."
                    copy="Reliable suppliers are the foundation of our trading network. This is how we review supplier information and match genuine, verified buyer requirements."
                />

                <PageSection eyebrow="The Supplier Journey" title="From Review to Relationship" testid="supplier-steps">
                    <NumberSteps steps={SUPPLIER_STEPS} />
                    <div className="mt-10">
                        <DisclaimerBox text={TRADING_DISCLAIMER} testid="suppliers-disclaimer" />
                    </div>
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Introduce your company and products."
                            primary={{ label: "Trading Enquiry", to: "/trading-enquiry", testid: "suppliers-enquiry-cta" }}
                            secondary={{ label: "Partnership Enquiry", to: "/partnership-enquiry", testid: "suppliers-partnership-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
